import { LANGUAGE_NAMES, SUPPORTED_LANGUAGES, type SupportedLanguage } from './config';

/**
 * Check if language code is supported
 */
export function isSupportedLanguage(lang: string): lang is SupportedLanguage {
  return SUPPORTED_LANGUAGES.includes(lang as SupportedLanguage);
}

/**
 * Get language name for display
 */
export function getLanguageName(lang: SupportedLanguage): string {
  return LANGUAGE_NAMES[lang] || lang;
}

/**
 * Get all supported languages
 */
export function getSupportedLanguages(): SupportedLanguage[] {
  return [...SUPPORTED_LANGUAGES];
}

/**
 * Validate and normalize language code
 */
export function normalizeLanguage(lang: string | undefined): SupportedLanguage {
  if (!lang) return 'es';
  const normalized = lang.toLowerCase().split('-')[0] as SupportedLanguage;
  return isSupportedLanguage(normalized) ? normalized : 'es';
}
